import { CardMedia } from '@mui/material';

const LogoName = 'garud-logo.svg';

const logoWidth = '65px';

export const Logo1 = (): JSX.Element => {
  return (
    <CardMedia
      component="img"
      src={`/images/${LogoName}`}
      alt="Garud Investments Logo"
      sx={{ width: logoWidth, m: 3, mb: 2 }}
    />
  );
};

export const LogoEditApplication = (): JSX.Element => {
  return (
    <CardMedia
      component="img"
      src={`/images/${LogoName}`}
      alt="Garud InvestmentsLogo"
      sx={{ width: logoWidth, ml: { xs: 2, ms: 4 }, my: 1 }}
    />
  );
};

export const LogoSideBar = (): JSX.Element => {
  return (
    <CardMedia
      component="img"
      src={`/images/${LogoName}`}
      alt="Garud Investments Logo"
      sx={{ width: logoWidth, my: 1 }}
    />
  );
};
